"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFbCookieValueBasedOnType = exports.generateFbBrowserRandomId = exports.isFbclidNewerInUrlThanAlreadyKnown = exports.isFbcMissingAndFbclidPresent = exports.getFbclidFromCookieOrLdStorage = exports.getFbclidFromUrl = exports.getsFbIdIfKnown = exports.shouldMakeNewFbId = exports.checkExistingFbId = exports.makeFbId = exports.storeFbIds = void 0;
const ldLocalStorage_1 = require("./ldLocalStorage");
/**
 * Gets FB IDs or makes them. It sends them back to the ldPayload object
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns fills the IDs in the payloadCallback object
 */
const storeFbIds = (payloadCallback) => {
    (0, exports.checkExistingFbId)(payloadCallback);
    (0, exports.shouldMakeNewFbId)(payloadCallback);
};
exports.storeFbIds = storeFbIds;
/**
 * Makes FB IDs ('fbp' and 'fbc'). This is important when FB is blocked by
 * the browser extension, or when the FB script doesn't make cookies.
 * @param {FbIdType} type 'fbp' or 'fbc
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns {void} fills in the information in the callback
 */
const makeFbId = (type, payloadCallback) => {
    switch (type) {
        case "fbp":
            payloadCallback["_fbp-clientID"] = `fb.1.${new Date().getTime()}.${(0, exports.generateFbBrowserRandomId)()}`;
            break;
        case "fbc":
            payloadCallback["_fbc-clientID"] = `fb.1.${new Date().getTime()}.${(0, exports.getFbclidFromUrl)()}`;
            break;
        default:
            return;
    }
};
exports.makeFbId = makeFbId;
/**
 * Checks if the FB ID is known and fills in the information in the ldPayload
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns {string | undefined} fills in the information in the callback
 */
const checkExistingFbId = (payloadCallback) => {
    const fbpValue = (0, exports.getsFbIdIfKnown)("fbp");
    const fbcValue = (0, exports.getsFbIdIfKnown)("fbc");
    if (fbpValue)
        return (payloadCallback["_fbp-clientID"] = fbpValue);
    if (fbcValue && !(0, exports.isFbclidNewerInUrlThanAlreadyKnown)())
        return (payloadCallback["_fbc-clientID"] = fbcValue);
};
exports.checkExistingFbId = checkExistingFbId;
/**
 * If the FB IDs are not known, invoke makeFbId function to create appropriate ID.
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns {void} invokes makeFbId function
 */
const shouldMakeNewFbId = (payloadCallback) => {
    if (!(0, exports.getsFbIdIfKnown)("fbp"))
        return (0, exports.makeFbId)("fbp", payloadCallback);
    if ((0, exports.isFbcMissingAndFbclidPresent)() || (0, exports.isFbclidNewerInUrlThanAlreadyKnown)())
        return (0, exports.makeFbId)("fbc", payloadCallback);
};
exports.shouldMakeNewFbId = shouldMakeNewFbId;
/**
 * Checks if FB ID is present in the cookie. If not, returns the value
 * from LD localStorage.
 * @param {FbIdType} type 'fbp' or 'fbc'
 * @returns {string | undefined} 'fbp' or 'fbc' value or undefined
 */
const getsFbIdIfKnown = (type) => {
    var _a;
    return (0, exports.getFbCookieValueBasedOnType)(type) ||
        ((_a = (0, ldLocalStorage_1.getLDLocalStorage)()) === null || _a === void 0 ? void 0 : _a[`_${type}-clientID`]);
};
exports.getsFbIdIfKnown = getsFbIdIfKnown;
/**
 * Gets 'fbclid' from the URL parameter
 * @returns {string | null} 'fbclid' value if available, null otherwise
 */
const getFbclidFromUrl = () => new URL(location.href).searchParams.get("fbclid");
exports.getFbclidFromUrl = getFbclidFromUrl;
/**
 * Returns the 'fbclid' value from the cookie
 * or from the LD localStorage - if either is known.
 * @returns {string | undefined} 'fbclid' value if available, undefined otherwise
 */
const getFbclidFromCookieOrLdStorage = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const fbcCookieValue = (0, exports.getFbCookieValueBasedOnType)("fbc");
    if (!fbcCookieValue) {
        return (_e = (_d = (_c = (_b = (_a = (0, ldLocalStorage_1.getLDLocalStorage)()) === null || _a === void 0 ? void 0 : _a["_fbc-clientID"]) === null || _b === void 0 ? void 0 : _b.split) === null || _c === void 0 ? void 0 : _c.call(_b, ".")) === null || _d === void 0 ? void 0 : _d.pop) === null || _e === void 0 ? void 0 : _e.call(_d);
    }
    return (_g = (_f = fbcCookieValue === null || fbcCookieValue === void 0 ? void 0 : fbcCookieValue.split(".")) === null || _f === void 0 ? void 0 : _f.pop) === null || _g === void 0 ? void 0 : _g.call(_f);
};
exports.getFbclidFromCookieOrLdStorage = getFbclidFromCookieOrLdStorage;
/**
 * Checking if 'fbc' is unknown and 'fbclid' is present in the URL
 * @returns {boolean} true or false
 */
const isFbcMissingAndFbclidPresent = () => !!(!(0, exports.getsFbIdIfKnown)("fbc") && (0, exports.getFbclidFromUrl)());
exports.isFbcMissingAndFbclidPresent = isFbcMissingAndFbclidPresent;
/**
 * We need to check if the 'fbclid' is present in the URL, and if so,
 * return the updated 'fbc' ID if it is newer than the current one.
 * This is necessary only when '_fbp' and '_fbc' cookies are not present
 * (ex. blocked by extension or FB script not making the cookie)
 * @returns {boolean} true or false
 */
const isFbclidNewerInUrlThanAlreadyKnown = () => {
    const fbclidInUrl = (0, exports.getFbclidFromUrl)();
    return ((0, exports.getFbclidFromCookieOrLdStorage)() != fbclidInUrl && fbclidInUrl !== null);
};
exports.isFbclidNewerInUrlThanAlreadyKnown = isFbclidNewerInUrlThanAlreadyKnown;
/**
 * Generating browser-specific ID. Method taken from FBs pixel script
 * @returns {string} generated browser-specific ID
 */
const generateFbBrowserRandomId = () => `${Math.round(2147483647 * Math.random())}`;
exports.generateFbBrowserRandomId = generateFbBrowserRandomId;
/**
 * Gets the Facebook cookie value (_fbp or _fbc)
 * @param {string} type fbp or fbc
 * @returns {string | undefined} if the cookie exists, returns string; otherwise, returns undefined
 */
const getFbCookieValueBasedOnType = (type) => {
    var _a;
    const cookies = document.cookie;
    return (_a = cookies
        .split("; ")
        .find((txt) => txt.startsWith(`_${type}=`))) === null || _a === void 0 ? void 0 : _a.split("=")[1];
};
exports.getFbCookieValueBasedOnType = getFbCookieValueBasedOnType;
